import axios from 'axios';

export const updatePersonalShipsurance = (payload) => {
  return axios.post('/shipsurance', payload);
};
